import { KeyboardArrowDown } from '@mui/icons-material';
import {
  Box,
  Button,
  Chip,
  Popover,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  IEcommerceProductHierarchy,
  IEcommerceProductHierarchyItem
} from 'src/models/ecommerce';
import useEcommerce from 'src/services/useEcommerce';
import FilterBrandList from './FilterBrandList';
import { reducerUpdateAdvanceSearch } from 'src/features/advanceSearchEcommerce';

export default function FilterBrand() {
  const theme = useTheme();
  const { selectedOriginalToPost, selectedBrand } = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );
  const [openBrand, setOpenBrand] = useState<boolean>(false);
  const [anchorElBrand, setAnchorElBrand] = useState<HTMLElement | null>(null);

  const dispatch = useAppDispatch();

  const projectId = useAppSelector((state) => state.users.project.id);
  const advanceSearchEcommerce = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );
  const { useGetEcommerceStreamCommentingToProduct } = useEcommerce();

  const {
    data: streamsCommentingToPostData,
    loading: loadingStreamsCommentingToPost
  } = useGetEcommerceStreamCommentingToProduct({
    skip: !openBrand,
    variables: {
      projectId: projectId
    },
    fetchPolicy: 'network-only'
  });

  const [selectedBrandLocal, setSelectedBrandLocal] =
    useState<IEcommerceProductHierarchy[]>(selectedBrand);
  const [
    selectedCommentingToProductsLocal,
    setSelectedCommentingToProductsLocal
  ] = useState<IEcommerceProductHierarchyItem[]>(selectedOriginalToPost);

  const handleOpenBrand = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElBrand(event.currentTarget);
    setOpenBrand(true);
  };

  const handleCloseBrand = () => {
    setAnchorElBrand(null);
    setOpenBrand(false);
  };

  const handleApply = () => {
    dispatch(
      reducerUpdateAdvanceSearch({
        ...advanceSearchEcommerce,
        replyToOriginalId: selectedCommentingToProductsLocal.map(
          (stream) => stream.originalId
        ),
        selectedOriginalToPost: selectedCommentingToProductsLocal,
        selectedBrand: selectedBrandLocal,
        selectedSubBrand: selectedBrandLocal.flatMap((item) => item.subBrands)
      })
    );
    handleCloseBrand();
  };

  useEffect(() => {
    setSelectedBrandLocal(selectedBrand);
    setSelectedCommentingToProductsLocal(selectedOriginalToPost);
  }, [selectedOriginalToPost, selectedBrand]);

  return (
    <>
      <Stack maxWidth="400px" width="100%" spacing={0.5}>
        <Typography variant="h5" fontWeight={600}>
          Brand
        </Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={handleOpenBrand}
          sx={{
            color: 'text.primary',
            backgroundColor: 'white',
            borderRadius: theme.spacing(1),
            maxWidth: '400px',
            width: '100%',
            minHeight: '36px',
            borderColor: (theme) =>
              openBrand ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.23)',
            '&:hover': {
              borderColor: 'rgba(0, 0, 0, 0.87)',
              backgroundColor: 'white'
            },
            '& .MuiButton-startIcon': { marginRight: 'auto' },
            '& .buttonText': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              textAlign: 'left',
              flex: '1'
            },
            padding: '4px 8px'
          }}
          endIcon={
            <KeyboardArrowDown
              sx={{
                transform: openBrand ? 'rotate(180deg)' : 'rotate(0)',
                marginRight: '2px'
              }}
            />
          }
        >
          {selectedBrand.length <= 0 ? (
            <span className="buttonText">All Brand</span>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'nowrap',
                gap: 0.5,
                // maxWidth: '320px',
                // maxWidth: '500px',
                width: '100%',
                overflow: 'scroll',
                scrollbarWidth: 'none'
              }}
            >
              {selectedBrand.map((group, index) => (
                <Chip
                  key={`${group}-${index}`}
                  variant="outlined"
                  sx={{
                    maxWidth: selectedBrand.length > 1 ? '150px' : '300px',
                    '& .MuiChip-label': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: 'block'
                    }
                  }}
                  label={group.name}
                  size="small"
                />
              ))}
            </Box>
          )}
        </Button>
      </Stack>
      <Popover
        open={openBrand}
        onClose={handleCloseBrand}
        anchorEl={anchorElBrand}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box sx={{ p: theme.spacing(2), maxWidth: '600px', width: '100%' }}>
          <Typography variant="h4">Brand</Typography>
          <Box
            sx={{ mt: theme.spacing(1), maxHeight: '300px', overflow: 'auto' }}
          >
            <FilterBrandList
              data={
                streamsCommentingToPostData?.ecommerceProductManagement_getProductHierarchy ||
                []
              }
              loading={loadingStreamsCommentingToPost}
              selectedProducts={selectedCommentingToProductsLocal}
              onSelectedProductsChange={(
                products: IEcommerceProductHierarchyItem[]
              ) => {
                setSelectedCommentingToProductsLocal(products);
              }}
              selectedBrand={selectedBrandLocal}
              setSelectedBrand={setSelectedBrandLocal}
            />
          </Box>
          <Stack pt={2} alignItems="end">
            <Button variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
